// Admin API client — /admin/subscriptions/* (mirrors the API's subscriptions aggregate).

import type {
  AdminSubscription,
  AdminSubscriptionDetail,
  StripeSubscriptionStatus,
} from '@a7y/types';
import { client } from './transport';

export const subscriptionsApi = {
  // Subscriptions (sourced from Stripe API)
  getSubscriptions: (params?: {
    statuses?: StripeSubscriptionStatus[] | 'all';
    limit?: number;
    starting_after?: string;
    env?: 'sandbox' | 'production' | 'all';
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.statuses && params.statuses !== 'all' && params.statuses.length > 0) {
      searchParams.set('statuses', params.statuses.join(','));
    } else {
      searchParams.set('statuses', 'all');
    }
    if (params?.starting_after) searchParams.set('starting_after', params.starting_after);
    if (params?.env) searchParams.set('env', params.env);
    return client.get<{ data: AdminSubscription[]; hasMore: boolean; nextCursor: string | null }>(
      `/subscriptions?${searchParams}`
    );
  },
  getSubscriptionDetail: (subscriptionId: string) =>
    client.get<AdminSubscriptionDetail>(`/subscriptions/${subscriptionId}`),
};
